<template>
  <div class="content" ref="content">
    <div class="main-content" style="background: #f8fbfc">
      <div class="top-info" ref="top" v-if="!checkWriter">
        <div class="info-box">
          <div class="info-image" style="color: #91d5ff">
            <icon-font style="font-size: 0.4rem" type="icon-dingdan1" />
          </div>
          <div class="info">
            <div class="info-title">订单总数量</div>
            <div class="info-value">
              {{ stat.orderCount }}
            </div>
          </div>
        </div>

        <div class="info-box">
          <div class="info-image">
            <icon-font style="font-size: 0.4rem" type="icon-zhanghuyue" />
          </div>
          <div class="info">
            <div class="info-title">订单金额</div>
            <div class="info-value">{{ stat.orderAmount }}</div>
          </div>
        </div>

        <div class="info-box">
          <div class="info-image" style="color: red">
            <icon-font style="font-size: 0.4rem" type="icon-dingdan" />
          </div>
          <div class="info">
            <div class="info-title">待指派订单数</div>
            <div class="info-value">{{ stat.recriveOrderCount }}</div>
          </div>
        </div>
        <div class="info-box">
          <div class="info-image">
            <icon-font style="font-size: 0.4rem" type="icon-dingdan" />
          </div>
          <div class="info">
            <div class="info-title">进行中的订单</div>
            <div class="info-value">{{ stat.aheadOrderCount }}</div>
          </div>
        </div>
        <div class="info-box">
          <div class="info-image" style="color: cyan">
            <icon-font style="font-size: 0.4rem" type="icon-dingdan" />
          </div>
          <div class="info">
            <div class="info-title">已完成订单</div>
            <div class="info-value">{{ stat.doneOrderCount }}</div>
          </div>
        </div>
      </div>

      <div class="line-content">
        <div class="line-box">
          <div class="line-title">每日订单统计</div>
          <div class="line">
            <ELine
              ref="eLine"
              :loading="loading"
              :source="source"
              :styles="'width:100%;height:' + height + 'px'"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent, ref } from 'vue'
import ELine from '@/components/echarts/line'
import { StatClass } from '@/apis/user'

const api = new StatClass()
export default defineComponent({
  components: {
    ELine
  },
  setup () {
    const loading = ref(false)
    const source = ref([])
    const height = ref(300)
    const stat = ref({
      orderCount: 0,
      recriveOrderCount: 0,
      refuseOrderCount: 0,
      aheadOrderCount: 0,
      checkOrderCount: 0,
      balanceOrderCount: 0,
      writerCount: 0,
      orderAmount: 0,
      adFeeAmount: 0,
      writerAmount: 0
    })

    const onGetStat = () => {
      api.info().then(resp => {
        stat.value = resp
      })
    }

    const onGetLineDatas = () => {
      loading.value = true
      api.line().then(resp => {
        source.value = resp
        loading.value = false
      })
    }

    onGetStat()
    onGetLineDatas()

    return {
      loading,
      stat,
      source,
      height
    }
  },

  mounted () {
    this.$nextTick(() => {
      this.getHeight()
    })
  },

  computed: {
    checkWriter () {
      const roleId = this.$store.state.user.userInfo.roleIds[0]
      return [4, 5].includes(roleId)
    }
  },

  methods: {
    navigate (path) {
      this.$router.push({ path })
    },
    getHeight () {
      const mainPadding = 30
      const thead = 56
      const height =
        this.$refs.content.offsetHeight -
        this.$refs.top.offsetHeight -
        thead -
        80 -
        mainPadding

      this.height = height
    }
  }
})
</script>

<style lang="less" scoped>
.top-info {
  display: flex;
  flex-wrap: wrap;
  .info-box {
    display: flex;
    border-radius: 20px;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
    background: #fff;
    width: 19.6%;
    margin: 0 0.2% 10px;

    &.info-box-2{
      width: 24.6%;
    }
    .info-image {
      width: 1rem;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
    }
    .info {
      padding: 0.1rem 0 0.1rem 0.2rem;
      .info-title {
        font-size: 0.18rem;
        color: #666666;
        line-height: 0.35rem;
      }
      .info-value {
        color: #333333;
        font-size: 0.3rem;
        line-height: 0.45rem;
        span {
          font-size: 14px;
          color: #999999;
        }
      }
    }

    &.box-1 {
      .info-image {
        background: #ceffa6;
      }
    }
    &.box-2 {
      .info-image {
        background: #ffb2c9;
      }
    }
    &.box-3 {
      .info-image {
        background: #ffd890;
      }
    }
    &.box-4 {
      .info-image {
        background: #e590ff;
      }
    }
  }
}

.line-content {
  padding-top: 30px;
  .line-box {
    padding: 20px 40px;
    border-radius: 20px;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
    background: #fff;
    .line-title {
      display: flex;
      align-items: center;
      font-size: 26px;
      color: #333333;
      &:before {
        content: "";
        display: block;
        height: 23px;
        border-left: 3px solid #185ef9;
        width: 26px;
      }
    }

    .line {
    }
  }
}
</style>
